import { Box, Typography } from "@mui/material";
import { memo } from "react";

import type { EmptyStateProps } from "./EmptyState.types";
import * as styles from "./EmptyState.styles";

export type { EmptyStateProps } from "./EmptyState.types";

export const EmptyState = memo(function EmptyState({
  icon,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <Box sx={styles.root}>
      {icon ?? null}
      <Typography variant="body2" sx={styles.title}>
        {title}
      </Typography>
      {description ? (
        <Typography variant="caption" sx={styles.description}>
          {description}
        </Typography>
      ) : null}
      {action ?? null}
    </Box>
  );
});
